import { render } from "./simpleImageTeaser.vue?vue&type=template&id=738f6f35"
import script from "./simpleImageTeaser.vue?vue&type=script&lang=js"
export * from "./simpleImageTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__